import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-three-sections-layout-2-component`,
    templateUrl: 'threeSectionsLayout2.component.html',
    styleUrls: ['../layout.component.scss']
})

export class ThreeSectionsLayout2Component extends LayoutComponent { }

export class ThreeSectionsLayout2 extends Layout {
    public type = 'ThreeSectionsLayout2';
    public componentType = ThreeSectionsLayout2Component;
    public numberOfSections = 3;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout2/threeSectionsLayout2.component.ts